module.exports = __webpack_public_path__ + "static/media/02_MRS-3.0-EC-14.0-TI-SC.95a097fb.png";